<script setup lang="ts">
import { TransportType } from '@libs/trip-planner-interfaces';

import type { ItineraryUpsellNoTransportSegment } from '../../models';
import { useTripOverviewPageStore } from '../../stores';

import TransportBanner from './upsell/TransportBanner.vue';

interface ItineraryUpsellNoTransportSegmentProps {
  segment: ItineraryUpsellNoTransportSegment;
}

const props = defineProps<ItineraryUpsellNoTransportSegmentProps>();

const tripOverviewPageStore = useTripOverviewPageStore();

function selectTransport(transport: TransportType): void {
  tripOverviewPageStore.selectTransport(props.segment, transport);
}
</script>

<template>
  <TransportBanner
    :country="segment.destination"
    @add-flight="selectTransport(TransportType.Flight)"
    @add-ferry="selectTransport(TransportType.Ferry)"
    @select-transport="selectTransport($event)"
  />
</template>

<style scoped lang="scss">
.exp-transport-banner {
  margin: 0 var(--spacing-24) var(--spacing-24) var(--spacing-24);

  @include for-less-or-equal-than-599-px {
    margin: 0 var(--spacing-12) var(--spacing-24) var(--spacing-12);
  }

  ::after {
    content: '';
    height: 25px;
    width: 0px;
    border-right: 1px dashed var(--color-neutral-70);
    position: absolute;
    bottom: -25px;
    left: 24px;
  }
}
</style>
